import API from "../../core/apiConfig";
import { normalizePaginatedResponse } from "../../core/response";
import type {
  BusinessPlanCostSheetChange,
  BusinessPlanPayload,
  BusinessPlanRequestOptions,
  BusinessPlanStateAction,
  BusinessPlanStatePayload,
} from "./types";

const getAllBussinessPlan = async (
  params: Record<string, unknown>,
  options?: BusinessPlanRequestOptions,
) => {
  const response = await API.get("/admin/businessPlan", {
    params,
    silentLoading: options?.silentLoading ?? false,
  }).then((res) => res.data);

  if (response.success) {
    return normalizePaginatedResponse(response, "page");
  }
};

const getDetailBussinessPlan = async (id: string) => {
  const response = await API.get(
    `/admin/businessPlan/${id}/cost-sheet`,
  ).then((res) => res.data);

  if (response.success) return response.data;
};

const postAddBussinessPlan = async (data: BusinessPlanPayload) => {
  const response = await API.post("/admin/businessPlan", data).then(
    (res) => res.data,
  );

  if (response.success) return response.data;
};

const putUpdateBussinessPlan = async (
  data: BusinessPlanPayload,
  id: string,
) => {
  const response = await API.put(`/admin/businessPlan/${id}`, data).then(
    (res) => res.data,
  );

  if (response.success) return response.data;
};

const patchUpdateBussinessPlanCostSheet = async (
  changes: BusinessPlanCostSheetChange[],
  id: string,
) => {
  const response = await API.patch(
    `/admin/businessPlan/${id}/cost-sheet/cells`,
    { changes },
  ).then((res) => res.data);

  if (response.success) return response.data;
};

const patchUpdateBussinessPlanCostSheetPreview = async (
  changes: BusinessPlanCostSheetChange[],
  id: string,
) => {
  const response = await API.patch(
    `/admin/businessPlan/${id}/cost-sheet/cells/calculate`,
    { changes },
  ).then((res) => res.data);

  if (response.success) return response.data;
};

const putStateBussinessPlanCostSheet = async (
  id: string,
  type: BusinessPlanStateAction,
  payload: BusinessPlanStatePayload,
) => {
  const response = await API.put(
    `/admin/businessPlan/${id}/${type}`,
    payload,
  ).then((res) => res.data);

  if (response.success) return response.data;
};

export default {
  getAllBussinessPlan,
  getDetailBussinessPlan,
  postAddBussinessPlan,
  putUpdateBussinessPlan,
  patchUpdateBussinessPlanCostSheet,
  putStateBussinessPlanCostSheet,
  patchUpdateBussinessPlanCostSheetPreview,
};
